import React from 'react'
import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    padding: spacing(2, 5)
  }
}))

const StepContent = ({ children }) => {
  const classes = useStyles()
  return <Box className={classes.root}>{children}</Box>
}

export default StepContent
